export default class ScrollToContent {
	constructor() {
		this.scrollToEl = document.querySelector('.scroll-down');
		if (!this.scrollToEl) return;

		this.scrollTo = this.scrollToEl.dataset.scrollTo;
		if (!this.scrollTo) return;

		this.scrollStopEl = document.querySelectorAll(this.scrollTo);
		if (!this.scrollStopEl || !this.scrollStopEl.length > 0) return;

		this.scrollStopEl = this.scrollStopEl.item(0);
		if (!this.scrollStopEl) return;

		this.events();
	}

	events() {
		this.scrollToEl.addEventListener('click', (e) => {
				e.preventDefault();
				this.scrollStopEl.scrollIntoView({ behavior: 'smooth' });
			},
			false
		);
	}
}

new ScrollToContent();
